import { render, staticRenderFns } from "./marketInfo.vue?vue&type=template&id=63027fd4&scoped=true"
import script from "./marketInfo.vue?vue&type=script&lang=js"
export * from "./marketInfo.vue?vue&type=script&lang=js"
import style0 from "./marketInfo.vue?vue&type=style&index=0&id=63027fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63027fd4",
  null
  
)

export default component.exports